function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome2R({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 341,
    height: 405,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#e6abab",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.514,
    cy: 202.394,
    fill: "#FFBABA",
    rx: 264.733,
    ry: 194.226,
    style: {
      fill: "#e6abab",
      fillOpacity: 1
    },
    transform: "rotate(-18.26 259.514 202.394)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome2R);
export default __webpack_public_path__ + "static/media/bg_home2_r.6b51727527731e091cd39788b12e4f2a.svg";
export { ForwardRef as ReactComponent };